import { Box, Button, Stack, Zoom } from "@mui/material";
import { Category } from "../../../../domain/model/Category";
import {
  COLOR_BLACK,
  COLOR_LIGHT_GRAY,
  COLOR_MAIN,
  COLOR_SECONDARY,
  COLOR_VERY_LIGHT_GRAY,
  COLOR_WHITE,
} from "../../../../data/colors/Colors";
import { CustomCardView } from "../../../component/CustomCardView";
import { CustomImageView } from "../../../component/CustomImageView";
import { CustomTextView } from "../../../component/CustomTextView";
import {
  getDominantColorOfImage,
  hasEnglishLetters,
} from "../../../../core/utils/Utils";
import { useEffect, useState } from "react";
import { CategoryOutlined, CategoryRounded } from "@mui/icons-material";
import useWindowDimensions from "../../../../core/utils/UseWindowDimensions";
import { Store } from "../../../../domain/model/Store";

interface props {
  store: Store;
  index: number;
  href: string;
}

export function StoresListItemView(props: props) {
  const { width } = useWindowDimensions();

  return (
    <Box
    // sx={{
    //   "&:hover": {
    //     transform: width < 900 ? undefined : "scale3d(1.01, 1.01, 1)",
    //     zIndex: "1",
    //   },
    //   transition: "transform 0.2s ease-in-out",
    // }}
    >
      <CustomCardView
        padding={0}
        borderRadius={6}
        border={"1px solid " + COLOR_LIGHT_GRAY}
        children={
          <Button
            LinkComponent={"a"}
            fullWidth
            href={props.href}
            sx={{
              padding: 0,
              // "&:hover": { background: COLOR_VERY_LIGHT_GRAY },
              borderRadius: 6,
            }}
          >
            <Stack
              spacing={0}
              textTransform={"none"}
              width={"100%"}
              position={"relative"}
              height={280}
            >
              <Zoom in timeout={500}>
                <div>
                  <CustomImageView
                    height={280}
                    width="100%"
                    src={props.store.logo}
                    props={{ borderRadius: 6 }}
                  />
                </div>
              </Zoom>
              <Stack position={"absolute"} bottom={0} zIndex={2} width={"100%"}>
                <Stack
                  pr={2}
                  pl={2}
                  pb={1}
                  pt={1}
                  sx={{
                    direction: hasEnglishLetters(props.store.name ?? "")
                      ? "ltr"
                      : "rtl",
                    backdropFilter: "blur(10px)",
                    backgroundColor: "rgba(0, 0, 0, 0.3)",
                    borderTop: "0.3px solid lightGray",
                    borderRadius: 6,
                  }}
                  spacing={0.5}
                  direction={"row"}
                >
                  <CustomTextView
                    text={`#${props.index + 1}`}
                    fontSize={20}
                    fontWeight="300"
                    textColor={COLOR_WHITE}
                  />
                  <CustomTextView
                    text={props.store.name}
                    fontWeight="bold"
                    fontSize={22}
                    textColor={COLOR_WHITE}
                    props={{
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      overflowWrap: "break-word",
                      whiteSpace: "nowrap",
                    }}
                  />
                </Stack>
              </Stack>
            </Stack>
          </Button>
        }
      />
    </Box>
  );
}
